export default {
	tabs: {
		all: 'Tümü',
		sales: 'Satışlar',
		purchases: 'Satın Alınanlar',
		'sales-refund': 'Satış İadesi'
	},
	sale: 'Satış',
	purchases: 'Satın Alma',
	'sales-returns': 'Satış İadesi',
	ascending: 'En eski',
	descending: 'En yeni',
	'view-the-associated-invoice': 'İlgili faturayı görüntüle',
	'view-associated-journal': 'İlgili yövmiyeyi görüntüle',
	print: 'Yazdır',
	'sort-by-status': 'Duruma göre sırala',
	'posted-first': 'Önce devredilen',
	'not-posted-first': 'Önce taslaklar',
}